<template>
  <nav class="nav-bar" role="navigation">
    <div class="title hidden-on-desktop text-xsmall medium-bold">SHOP</div>

    <ul class="site-nav" id="AccessibleNav">
      <li
        v-for="(link, index) in links"
        :key="index"
        @mouseover="() => (link.childLinks.length ? showSubMenu(index) : hideSubMenu())"
        @mouseleave="hideSubMenu"
      >
        <NavLink :link="link" class="site-nav__link main-nav-link" />
        <transition name="fade">
          <ChildLinkList
            class="sub-menu"
            v-if="subMenuIndex === index"
            :childLinks="link.childLinks"
          />
        </transition>
        <ChildLinkList class="child-links" :childLinks="link.childLinks" />
      </li>
    </ul>

    <p class="title hidden-on-desktop">
      <small>Account</small>
    </p>

    <ul class="site-nav hidden-on-desktop">
      <li v-if="!isLoggedIn">
        <a href="/account/login">Login</a>
      </li>

      <li v-if="!isLoggedIn">
        <a href="/account/register">Register</a>
      </li>

      <li v-if="isLoggedIn">
        <a href="/account">My Details</a>
      </li>

      <li v-if="isLoggedIn">
        <a href="/account#order-history">Order History</a>
      </li>

      <li v-if="isLoggedIn">
        <a href="/account/addresses">Address Book</a>
      </li>

      <li class="cart">
        <a href="/pages/wishlist"
          >Wishlist
          <span class="slash">/</span>
          <span class="wishListCounterID">{{ wishlistCount }}</span>
        </a>
      </li>

      <li class="cart">
        <a href="/cart"
          >My Bag
          <span class="slash">/</span>
          <span class="CartCount">{{ cartCount }}</span>
        </a>
      </li>

      <li v-if="isLoggedIn">
        <a href="/account/logout">Logout</a>
      </li>
    </ul>
  </nav>
</template>


<script>
import { mapGetters } from 'vuex'
import ProcessLiquid from '../../mixins/ProcessLiquid.js'
import ChildLinkList from './ChildLinkList.vue'
import NavLink from '../atoms/NavLink.vue'

export default {
  mixins: [ProcessLiquid],
  components: {
    ChildLinkList,
    NavLink,
  },
  data: () => ({
    links: 'liquid:linklists.main-menu',
    subMenuIndex: null,
  }),
  computed: mapGetters(['isLoggedIn', 'wishlistCount', 'cartCount']),
  methods: {
    showModal() {
      this.$emit('show-modal', false)
    },
    orderHistory() {
      window.location.href = '/account#order-history'
    },
    showSubMenu(index) {
      this.subMenuIndex = index
    },
    hideSubMenu() {
      this.subMenuIndex = null
    },
  },
}
</script>
